import { RadioCard, RadioGroup, Stack, Text, textVariants } from '@etg/wings';
import { constants, date as dateUtil } from '@eti/utils';
import { useDateFormat, useTranslation } from '@eti/providers';
import type { ChangeEventHandler } from 'react';
import { css } from '@eti/styles';
import type { AddOnOrdersType } from '../../../models';

const purchaseDateStyles = css`
  color: #737373;
`;

interface AddonOrdersRadioGroupProps {
  dataTestIdPrefix: string;
  addOnOrders: NonNullable<AddOnOrdersType>;
  orderNumber: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  purchaseDate: string;
  selectedValue: string | null;
}

const AddonOrdersRadioGroup = ({
  addOnOrders,
  dataTestIdPrefix,
  onChange,
  orderNumber,
  purchaseDate,
  selectedValue,
}: AddonOrdersRadioGroupProps) => {
  const { t } = useTranslation();
  const { dayYear } = useDateFormat();

  return (
    <RadioGroup name="addonOrders" onChange={onChange} selectedValue={selectedValue}>
      <Stack spacing={4}>
        <RadioGroup.Legend>
          {t('Receipt.ReceiptDetails.PrintModal.AddOnOrdersTitle')}
        </RadioGroup.Legend>
        <RadioCard
          data-testid={`${dataTestIdPrefix}-mainOrder`}
          id="option1"
          label={
            <Stack className={constants.MOUSE_FLOW_CLASS_NAMES} spacing={0}>
              <Text variant={textVariants._14_BOLD}>{orderNumber}</Text>
              <Text className={purchaseDateStyles}>
                {t(
                  'Receipt.ReceiptDetails.PrintModal.Purchased.Label',
                  dateUtil.format(purchaseDate, dayYear),
                )}
              </Text>
            </Stack>
          }
          value={orderNumber}
        />
        {addOnOrders.map(
          (addonOrder, index) =>
            addonOrder?.orderNumber && (
              <RadioCard
                data-testid={`${dataTestIdPrefix}-addonOrder-${index + 1}`}
                id={addonOrder.orderNumber}
                key={addonOrder.orderNumber}
                label={
                  <Stack className={constants.MOUSE_FLOW_CLASS_NAMES} spacing={0}>
                    <Text variant={textVariants._14_BOLD}>{addonOrder.customerOrderReference}</Text>
                    <Text className={purchaseDateStyles}>
                      {t(
                        'Receipt.ReceiptDetails.PrintModal.Purchased.Label',
                        dateUtil.format(addonOrder.creationDate, dayYear),
                      )}
                    </Text>
                  </Stack>
                }
                value={addonOrder.orderNumber}
              />
            ),
        )}
      </Stack>
    </RadioGroup>
  );
};

export default AddonOrdersRadioGroup;
